import { ReactNode } from 'react';
import { Box } from 'ui';
import { useDocumentTitle } from './useDocumentTitle';
import { SxProps, Theme, css, styled } from '@mui/material';
import { PageHeaderWithBreadcrumbs } from '../PageHeaderWithBreadcrumbs';
import { isRenderedAsIframeInNewUI } from 'config';

interface Props {
  documentTitle?: string;
  children: ReactNode | ReactNode[];
  sx?: SxProps<Theme>;
  shouldViewPageHeader?: boolean;
}

const HeaderRoot = styled(Box)`
  ${({ theme }) => css`
    height: ${theme.spacing(9)};
    background: #232430;
    padding: ${theme.spacing(1, 2)};
    display: flex;
    align-items: center;
  `}
`;

const PageHeader = ({ documentTitle = 'Cynet', shouldViewPageHeader = false, children, sx }: Props) => {
  useDocumentTitle(documentTitle);
  if (isRenderedAsIframeInNewUI && !shouldViewPageHeader) return null;
  return (
    <HeaderRoot justifyContent="space-between" sx={sx}>
      {typeof children === 'string' ? (
        <PageHeaderWithBreadcrumbs pageTitle={children}>{children}</PageHeaderWithBreadcrumbs>
      ) : (
        children
      )}
    </HeaderRoot>
  );
};

export default PageHeader;
